require('./CreditCardInitialAdditionalInfoSection.scss');

// @ vendors
import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
// @ utilities
import { formatText, FormattedText } from 'core/i18n';
import { recordCreditCardEvent, PAGE_INITIAL } from 'utilities/uTagging';
import { PROCESS_TYPE_ONBOARDING } from 'utilities/uTagConstants';
import { buildPartnerPrivateUrl } from 'utilities/buildURLs';
// @ components
import Accordion from 'components/commons/accordion/accordion';
import AccordionBody from 'components/commons/accordion/accordionBody/accordionBody';
import BoxOptionsContainer from 'components/newAccountSteps/profileSteps/profileStep3/BoxOptions/BoxOptionsContainers/BoxOptionsContainer';
import CreditCardFeature from '../commons/CreditCardFeature';
import CreditCardAnchorButton from '../commons/CreditCardAnchorButton';
import ConditionalToggling from 'utilities/toggling/ConditionalToggling/ConditionalToggling';
import { LoginModal } from 'components/commons/loginForm/LoginModal';
// @ icons
import future from 'assets/icons/future.svg';
// @ constants
import { getCreditCardAdditionalInfoFeatures, getCreditCardInfoBoxes } from 'constants/creditCard/initialStepSections';
import { API_APPLICATION } from 'constants/index';
import { PATH_CREDIT_CARD_ONBOARDING } from 'constants/uTagConstants/paths';
import { EVENT_CREDIT_CARD } from 'constants/uTagConstants/RAConstants';

const THEME1 = 'theme1';
const THEME2 = 'theme2';
const THEME3 = 'theme3';
class CreditCardInitialAdditionalInfoSection extends Component {
    state = {
        showLoginForm: false,
    };

    handleClickLogin = () => {
        this.setState({ showLoginForm: !this.state.showLoginForm });
    };

    handleClickShowLogin = () => {
        this.handleClickLogin();
        recordCreditCardEvent(
            PATH_CREDIT_CARD_ONBOARDING,
            PAGE_INITIAL,
            PROCESS_TYPE_ONBOARDING,
            EVENT_CREDIT_CARD,
            'haz click aqui accordion footer'
        );
    };

    handleRedirectLoginSuccess = (response, defaultLoginSuccess) => {
        if (response.application === API_APPLICATION) {
            location.href = buildPartnerPrivateUrl(this.props.partner.get('id'));
        } else {
            defaultLoginSuccess();
        }
    };

    buildBoxOptions = () => {
        return (
            <div className="open-box-options">
                {getCreditCardInfoBoxes(this.props.partner).map(({ title, content, img, customClass }, i) => (
                    <BoxOptionsContainer
                        boxCustomClass={customClass}
                        key={i}
                        title={formatText(title)}
                        content={formatText(content)}
                        img={img}
                    />
                ))}
                <CreditCardAnchorButton
                    text={formatText('initialInfoSection-getItButton')}
                    handleClick={() => {
                        recordCreditCardEvent(
                            PATH_CREDIT_CARD_ONBOARDING,
                            PAGE_INITIAL,
                            PROCESS_TYPE_ONBOARDING,
                            EVENT_CREDIT_CARD,
                            'consiguela ahora accordion body'
                        );
                    }}
                />
            </div>
        );
    };

    buildServices = () => {
        const theme = this.getTheme(this.props.partner.get('theme'));

        return (
            <div className={`container tc-accordion-body-sections ${theme}`}>
                {getCreditCardAdditionalInfoFeatures(this.props.partner).map(({ title, content, img, imgAlign }, i) => (
                    <CreditCardFeature
                        key={i}
                        title={formatText(title)}
                        content={formatText(content)}
                        img={img}
                        imgAlign={imgAlign}
                    />
                ))}
            </div>
        );
    };

    buildFooter = () => {
        const { tcDisplayLoginLink, partner } = this.props;
        const theme = this.getTheme(this.props.partner.get('theme'));

        return (
            <div className={`tc-accordion-footer ${theme}`}>
                {theme === THEME1 && <img src={future} className="tc-accordion-footer-icon" />}
                <div className="tc-accordion-footer-title">
                    {formatText(`initialAddInfoSection-footerTitle_${partner.get('id')}`)}
                </div>
                <CreditCardAnchorButton
                    text={formatText('initialInfoSection-getItButton')}
                    handleClick={() => {
                        recordCreditCardEvent(
                            PATH_CREDIT_CARD_ONBOARDING,
                            PAGE_INITIAL,
                            PROCESS_TYPE_ONBOARDING,
                            EVENT_CREDIT_CARD,
                            'consiguela ahora accordion footer'
                        );
                    }}
                />
                <p>
                    <FormattedText value={`initialInfoSection-clientLink_${this.props.partner.get('id')}`} />
                    <ConditionalToggling condition={tcDisplayLoginLink}>
                        <span className="tc-accordion-footer-link">
                            {formatText(`initialInfoSection-clientcontentLinkPart2_${this.props.partner.get('id')}`)}
                        </span>
                        <a onClick={() => this.handleClickShowLogin()} className="white-link">
                            {formatText(`initialInfoSection-clientLinkPart2_${this.props.partner.get('id')}`)}
                        </a>
                    </ConditionalToggling>
                </p>
                <p className="tc-accordion-footer-legal-condition">
                    <FormattedText
                        value={`initialAddInfoSection-descriptionFreeLegalText_${this.props.partner.get('id')}`}
                    />
                </p>
                <LoginModal
                    show={this.state.showLoginForm}
                    onClose={this.handleClickLogin}
                    onLoginSuccess={this.handleRedirectLoginSuccess}
                />
            </div>
        );
    };

    recordAccordionTolgging = isExpanded => {
        recordCreditCardEvent(
            PATH_CREDIT_CARD_ONBOARDING,
            PAGE_INITIAL,
            PROCESS_TYPE_ONBOARDING,
            EVENT_CREDIT_CARD,
            `chevron mas informacion ${isExpanded ? 'abrir' : 'cerrar'} `
        );
    };

    getTheme = theme => {
        switch (theme) {
            case '2':
                return THEME2;
            case '3':
                return THEME3;
            case '1':
            default:
                return THEME1;
        }
    };

    render() {
        const theme = this.getTheme(this.props.partner.get('theme'));

        return (
            <div>
                <Accordion
                    id="infoCreditCardHeader"
                    title={formatText('initialAddInfoSection-accordionTitle')}
                    expandable={true}
                    isExpanded={false}
                    customClassName={'tc-accordion'}
                    customTitleClassName={`tc-accordion-title ${theme}`}
                    customCollapsinToggle={'tc-accordion-toggle'}
                    recordEvent={this.recordAccordionTolgging}
                >
                    <AccordionBody name="AccordionBody">
                        <div className={`tc-accordion-body ${theme}`}>
                            {this.buildBoxOptions()}
                            <div className={`tc-accordion-body-title ${theme}`}>
                                {formatText('initialAddInfoSection-accordionBodyTitle')}
                            </div>
                            {this.buildServices()}
                        </div>
                        {this.buildFooter()}
                    </AccordionBody>
                </Accordion>
            </div>
        );
    }
}

CreditCardInitialAdditionalInfoSection.propTypes = {
    title: PropTypes.string,
    titleModifier: PropTypes.string,
    subTitleModifier: PropTypes.string,
    paragraphModifier: PropTypes.string,
    container: PropTypes.string,
    paragraph: PropTypes.string,
    dash: PropTypes.string,
    tcDisplayLoginLink: PropTypes.string,
};

module.exports = connect(state => ({
    userProfile: state.userProfile,
    partner: state.products.get('partner'),
}))(CreditCardInitialAdditionalInfoSection);
